import React from 'react';
import { loadCSS } from 'fg-loadcss';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > .fa': {
      margin: theme.spacing(2),
    },
  },
}));

export default function FontAwesomeIconComponent(props) {
  const classes = useStyles();
  const isDarkMode =
    document.documentElement.getAttribute('data-theme') === 'dark' ||
    document.body.classList.contains('dark-theme');

  React.useEffect(() => {
    const node = loadCSS(
      'https://use.fontawesome.com/releases/v5.12.0/css/all.css',
      document.querySelector('#font-awesome-css'),
    );

    return () => {
      node.parentNode.removeChild(node);
    };
  }, []);

  const iconStyle = {
    ...(props.colorName
      ? { color: 'var(--hrms-primary-blue-end, #036dda)' }
      : null),
    ...(props.style || {})
  };

  return (
    <Icon className={props.classes} fontSize={(props.fontSize) ? "small" : ""} style={iconStyle} />
  );
}
